import apiHandler from "../core/apiHandler";

/**
 * 📄 API base para PDF
 * de Corte Z histórico
 *
 * Endpoint:
 * /api/pdf/cash/closures/{closureId}
 */
const cashZPdfApi = apiHandler("pdf/cash/closures");

export default cashZPdfApi;
